// import React from 'react';
// import {
//   Dialog,
//   DialogContent,
//   DialogHeader,
//   DialogTitle,
// } from '@/components/ui/dialog';
// import { Button } from '@/components/ui/button';
// import { Recipe } from '@/types/index';
// import { useRecipes } from '@/hooks/useRecipes';
// import { Skeleton } from '@/components/ui/skeleton';

// interface AddMealDialogProps {
//   isOpen: boolean;
//   onClose: () => void;
//   onAddMeal: (recipe: Recipe) => void;
//   day: string;
//   mealType: string;
// }

// const RecipeCard = ({
//   recipe,
//   onAdd,
//   mealTypeDesc,
// }: {
//   recipe: Recipe;
//   onAdd: (r: Recipe) => void;
//   mealTypeDesc: string;
// }) => (
//   <div key={recipe.id} className="border rounded-lg overflow-hidden">
//     <img
//       src={recipe.image || '/placeholder-recipe.jpg'}
//       alt={recipe.title}
//       className="w-full h-32 object-cover"
//     />
//     <div className="p-3">
//       <h3 className="font-medium text-sm mb-2">{recipe.title}</h3>
//       <div className="text-xs text-gray-600 mb-3">
//         <p>{recipe.calories} calorías</p>
//         <p>
//           P: {recipe.protein}g | C: {recipe.carbs}g | G: {recipe.fat}g
//         </p>
//         <p className="mt-1 text-xs">
//           {recipe.time} • {recipe.difficulty}
//         </p>
//       </div>
//       <Button size="sm" onClick={() => onAdd(recipe)} className="w-full">
//         Agregar a {mealTypeDesc}
//       </Button>
//     </div>
//   </div>
// );

// const RecipeSkeleton = () => (
//   <div className="border rounded-lg overflow-hidden">
//     <Skeleton className="w-full h-32" />
//     <div className="p-3">
//       <Skeleton className="h-4 w-3/4 mb-2" />
//       <Skeleton className="h-3 w-1/2 mb-1" />
//       <Skeleton className="h-3 w-2/3 mb-3" />
//       <Skeleton className="h-8 w-full" />
//     </div>
//   </div>
// );

// const AddMealDialog = ({ isOpen, onClose, onAddMeal, day, mealType }: AddMealDialogProps) => {
//   const { recipes, loading, error } = useRecipes();
//   const mealTypeDesc = mealType;

//   // Filtrar recetas por categoría si es necesario (opcional)
//   const filteredRecipes = recipes.filter(recipe =>
//     recipe.category === mealType.toUpperCase() ||
//     recipe.tags?.includes(mealType.toUpperCase() as any)
//   );

//   // Usar todas las recetas o las filtradas
//   const displayRecipes = filteredRecipes.length > 0 ? filteredRecipes : recipes;

//   return (
//     <Dialog open={isOpen} onOpenChange={onClose}>
//       <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
//         <DialogHeader>
//           <DialogTitle>
//             Agregar {mealTypeDesc} para {day}
//           </DialogTitle>
//         </DialogHeader>

//         {error && (
//           <div className="bg-red-50 border border-red-200 rounded-md p-4">
//             <p className="text-red-800 text-sm">Error al cargar recetas: {error}</p>
//           </div>
//         )}

//         {loading ? (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
//             {Array.from({ length: 6 }).map((_, index) => (
//               <RecipeSkeleton key={index} />
//             ))}
//           </div>
//         ) : (
//           <>
//             <div className="text-sm text-gray-600 mb-4">
//               Mostrando {displayRecipes.length} recetas disponibles
//             </div>
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
//               {displayRecipes.map(recipe => (
//                 <RecipeCard
//                   key={recipe.id}
//                   recipe={recipe}
//                   onAdd={onAddMeal}
//                   mealTypeDesc={mealTypeDesc}
//                 />
//               ))}
//             </div>

//             {displayRecipes.length === 0 && (
//               <div className="text-center py-8 text-gray-500">
//                 No hay recetas disponibles.
//                 <br />
//                 <Button variant="link" className="mt-2">
//                   Crear nueva receta
//                 </Button>
//               </div>
//             )}
//           </>
//         )}
//       </DialogContent>
//     </Dialog>
//   );
// };

// export default AddMealDialog;
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription, // ✅ AÑADIR para eliminar el warning
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Recipe } from '@/types/index';
import { useRecipes } from '@/hooks/useRecipes';
import { Skeleton } from '@/components/ui/skeleton';
import { getCorrectImageUrl } from '@/utils/imageUtils'; // ✅ IMPORTAR

interface AddMealDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onAddMeal: (recipe: Recipe) => void;
  day: string;
  mealType: string;
}

const RecipeCard = ({
  recipe,
  onAdd,
  mealTypeDesc,
}: {
  recipe: Recipe;
  onAdd: (r: Recipe) => void;
  mealTypeDesc: string;
}) => {
  // ✅ PROCESAR LA URL DE LA IMAGEN
  const imageUrl = getCorrectImageUrl(recipe.image);

  return (
    <div key={recipe.id} className="border rounded-lg overflow-hidden hover:shadow-md transition-shadow duration-200">
      <img
        src={imageUrl}
        alt={recipe.title}
        className="w-full h-32 object-cover"
        onError={(e) => {
          // ✅ FALLBACK para imágenes que fallen
          e.currentTarget.src = 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80';
        }}
      />
      <div className="p-3">
        <h3 className="font-medium text-sm mb-2 line-clamp-2">{recipe.title}</h3>
        <div className="text-xs text-gray-600 mb-3 space-y-1">
          <p className="font-medium text-primary">{recipe.calories} calorías</p>
          <p className="flex gap-2">
            <span className="bg-emerald-50 text-emerald-700 px-1.5 py-0.5 rounded">P: {recipe.protein}g</span>
            <span className="bg-amber-50 text-amber-700 px-1.5 py-0.5 rounded">C: {recipe.carbs}g</span>
            <span className="bg-purple-50 text-purple-700 px-1.5 py-0.5 rounded">G: {recipe.fat}g</span>
          </p>
          <p className="text-xs text-gray-500 mt-1">
            {recipe.time} • {recipe.difficulty}
          </p>
        </div>
        <Button
          size="sm"
          onClick={() => onAdd(recipe)}
          className="w-full bg-primary hover:bg-primary/90"
        >
          Agregar a {mealTypeDesc}
        </Button>
      </div>
    </div>
  );
};

const RecipeSkeleton = () => (
  <div className="border rounded-lg overflow-hidden">
    <Skeleton className="w-full h-32" />
    <div className="p-3">
      <Skeleton className="h-4 w-3/4 mb-2" />
      <Skeleton className="h-3 w-1/2 mb-1" />
      <Skeleton className="h-3 w-2/3 mb-3" />
      <Skeleton className="h-8 w-full" />
    </div>
  </div>
);

const AddMealDialog = ({ isOpen, onClose, onAddMeal, day, mealType }: AddMealDialogProps) => {
  const { recipes, loading, error } = useRecipes();

  // ✅ CORREGIR: Convertir mealType a español para mostrar
  const getMealTypeDescription = (type: string): string => {
    const mealMap: { [key: string]: string; } = {
      'desayuno': 'Desayuno',
      'comida': 'Comida',
      'cena': 'Cena',
      'snack': 'Snack'
    };
    return mealMap[type] || type;
  };

  const mealTypeDesc = getMealTypeDescription(mealType);

  // Filtrar recetas por categoría si es necesario (opcional)
  const filteredRecipes = recipes.filter(recipe =>
    recipe.category === mealType.toUpperCase() ||
    recipe.tags?.includes(mealType.toUpperCase() as any)
  );

  // Usar todas las recetas o las filtradas
  const displayRecipes = filteredRecipes.length > 0 ? filteredRecipes : recipes;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            Agregar {mealTypeDesc} para {day}
          </DialogTitle>
          <DialogDescription> {/* ✅ AÑADIR para eliminar warning */}
            Selecciona una receta para agregar a tu menú semanal
          </DialogDescription>
        </DialogHeader>

        {error && (
          <div className="bg-red-50 border border-red-200 rounded-md p-4">
            <p className="text-red-800 text-sm">Error al cargar recetas: {error}</p>
          </div>
        )}

        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
            {Array.from({ length: 6 }).map((_, index) => (
              <RecipeSkeleton key={index} />
            ))}
          </div>
        ) : (
          <>
            <div className="text-sm text-gray-600 mb-4">
              Mostrando {displayRecipes.length} recetas disponibles
              {filteredRecipes.length > 0 && (
                <span className="text-primary font-medium"> (filtradas para {mealTypeDesc})</span>
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {displayRecipes.map(recipe => (
                <RecipeCard
                  key={recipe.id}
                  recipe={recipe}
                  onAdd={onAddMeal}
                  mealTypeDesc={mealTypeDesc}
                />
              ))}
            </div>

            {displayRecipes.length === 0 && (
              <div className="text-center py-8 text-gray-500">
                <p className="mb-2">No hay recetas disponibles para {mealTypeDesc}.</p>
                <Button variant="link" className="mt-2">
                  Crear nueva receta
                </Button>
              </div>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AddMealDialog;